import React from 'react'

const ServiceCenter = () => {
    return (
        <>
            <section className='service-center-wrap'>
                <div className='container'>
                    <div className='service-center-box d-flex align-items-center wow fadeIn' data-wow-duration="1s" data-wow-delay="0.5s">
                        <div className='sc-left'>
                            <div className='lg-title'>Service Center</div>
                            <ul className='common-list'>
                                <li>Full Service Department</li>
                                <li>Body Shop</li>
                                <li>Free Estimates</li>
                                <li>Free Loaner & Shuttle</li>
                            </ul>
                        </div>
                        <div className='sc-right'>
                            <a href='#' className='btn-white-theme'>Schedule Service</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ServiceCenter